import React, { Component } from 'react';
import '../../styles/components/filter.scss';
import i18n from '../../i18n';

export default class FilterSection extends Component {
  render() {
    const { children, loading, onSearch, onClear } = this.props;

    return (
      <div className="filter-section">
        <div className="filters">{children}</div>
        <div className="filter-actions">
          <button className="btn btn-primary btn-block rounded-5 button1-gray" disabled={loading} onClick={onClear}>
            {i18n.t('clear')}
          </button>
          <button className="btn btn-primary btn-block rounded-5" disabled={loading} onClick={onSearch}>
            {i18n.t('search')}
          </button>
        </div>
      </div>
    );
  }
}
